import { z } from "zod";
import { commentSchema } from "../comments/schemas";

export const tagLogicalOperatorSchema = z.enum(["AND", "OR"]);

// TODO: Create a schema for the search columns
export const searchColumnSchema = z.enum(["name", "description"]);

export const sortDirectionSchema = z.enum(["ASC", "DESC"]).optional();

export const attributeFilterSchema = z.object({
  attributeId: z.number().int(),
  values: z.array(z.string()),
});

export const tagFilterSchema = z.object({
  tagIds: z.array(z.number().int()),
  operator: tagLogicalOperatorSchema,
});

export const galleryRequestSchema = z.object({
  page: z.number().int(),
  pageSize: z.number().int(),
  filters: z.array(attributeFilterSchema),
  sortBy: z.string().nullable().optional(),
  sortDirection: sortDirectionSchema,
  tagFilters: tagFilterSchema.nullable().optional(),
  searchTerm: z.string().nullable().optional(),
  searchColumn: searchColumnSchema.nullable().optional(),
});

export const attributeValueSchema = z.object({
  attributeName: z.string(),
  value: z.string(),
});

export const galleryTagSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  color: z.string().optional(),
  type: z.string().optional(),
});

export const classificationSchema = z.object({
  tagName: z.string(),
  x: z.number(),
  y: z.number(),
  width: z.number(),
  height: z.number(),
  confidence: z.number(),
});

export const imageDimensionsSchema = z.object({
  width: z.number().int().optional(),
  height: z.number().int().optional(),
});

export const thumbnailResponseSchema = z.object({
  url: z.string(),
  width: z.number().int().nullable().optional(),
  height: z.number().int().nullable().optional(),
});

export const galleryItemSchema = z.object({
  id: z.number().int(),
  fileId: z.string(),
  name: z.string(),
  extension: z.string(),
  fileSize: z.number().int(),
  contentType: z.string().nullable(),
  viewCount: z.number().int(),
  createdDate: z.string(),
  modifiedDate: z.string().optional(),
  imageDimensions: imageDimensionsSchema.nullable().optional(),
  smallThumbnail: thumbnailResponseSchema.nullable().optional(),
  largeThumbnail: thumbnailResponseSchema.nullable().optional(),
  categoryName: z.string(),
  tags: z.array(galleryTagSchema),
  attributeValues: z.array(attributeValueSchema),
  comments: z.array(commentSchema).optional(),
  classifications: z.array(classificationSchema).optional(),
});

export const galleryResponseSchema = z.object({
  totalCount: z.number().int(),
  page: z.number().int(),
  pageSize: z.number().int(),
  totalPages: z.number().int(),
  filters: z.array(z.unknown()).optional(),
  items: z.array(galleryItemSchema),
});

export const attributeFilterOptionSchema = z.object({
  attributeId: z.number().int(),
  attributeName: z.string(),
  possibleValues: z.array(z.string()),
});

export const tagFilterOptionSchema = z.object({
  id: z.number().int(),
  name: z.string(),
});

export const galleryFilterSchema = z.object({
  filters: z.array(attributeFilterOptionSchema),
  tags: z.array(tagFilterOptionSchema),
});

export const galleryColumnOptionSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  order: z.number().int(),
});

export const galleryColumnSchema = z.object({
  columns: z.array(galleryColumnOptionSchema),
});

export const recentFeedItemSchema = z.object({
  categoryName: z.string(),
  categoryDisplayName: z.string().nullable().optional(),
  file: galleryItemSchema,
});

export const recentFilesBucketSchema = z.object({
  label: z.string(),
  items: z.array(recentFeedItemSchema),
});

export const recentFilesResponseSchema = z.object({
  totalCount: z.number().int(),
  page: z.number().int(),
  pageSize: z.number().int(),
  hasMore: z.boolean(),
  buckets: z.array(recentFilesBucketSchema),
});
